export default function addPropertyFilterRule(props) {
  const newProperty = {
    propertyId: props.sorterOptions.sorterProperties ? props.sorterOptions.sorterProperties.length + 1 : props.sorterOptions.length + 1,
    comparator: "DoubleComparator",
    property: "dynamicProperty",
    propertyType: "contextProperty",
    propertyValue: "",
    orderAscending: "desc",
  }
  props.handlePropertiesAdd(newProperty);
}